import { useContext } from "react";
import { Dropdown } from "../../../../shadcn/components/custom/Dropdown";
import { Context } from "services";

export const PDListSortByDropdown = ({
  onSelectSortOption = () => {},
  options = [],
}: {
  onSelectSortOption?: (option: any) => void;
  options: { label: string; value: string }[];
}) => {
  const { searchForm }: any = useContext(Context);

  const handleSortingOptions = (data: any) => {
    searchForm.value.sort_by = data;
    if (searchForm.value.sort_by) {
      onSelectSortOption?.(data);
    }
  };

  return (
    <div className="duration-300 ease-in-out flex items-center">
      <span className="mr-[13px] font-openSans text-sm font-normal leading-4 tracking-wide">
        Sort by:
      </span>
      <div>
        <Dropdown
          dataSource={() => Promise.resolve(options)}
          defaultSelected={
            searchForm.getField("sort_by") !== ""
              ? searchForm.getField("sort_by")
              : undefined
          }
          onChange={(value: any) => handleSortingOptions(value)}
          valueKey="value"
          placeholder="Filter"
          styles={{
            outerContainer:
              "border-[1px] border-brand-borderGrey min-w-[170px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack px-4",
          }}
        />
      </div>
    </div>
  );
};
